import React, { useContext } from 'react'
import { ActionIcon, Indicator, Popover } from '@mantine/core'
import { DatePicker, DatePickerProps } from '@mantine/dates'
import { FaRegCalendar } from 'react-icons/fa';
import UserSelectionContext from '../../providers/UserSelectionProvider';
import { normalizeDate } from '../../utils';
import DataContext from '../../providers/DataProvider';

interface RunPickerProps {
}

const RunPicker: React.FC<RunPickerProps> = ({ }) => {
    const { availableRuns, selectedRun, changeSelectedRun } = useContext(DataContext)

    const dateFilter = (date) => {
        const availableDates = availableRuns.map(r => normalizeDate(r.date).toISOString().split('T')[0]);
        const formattedDate = normalizeDate(date).toISOString().split('T')[0];
        return availableDates.findIndex(d => d === formattedDate);
    }

    const dayRenderer: DatePickerProps['renderDay'] = (date) => {
        return (
            <Indicator size={6} color="red" offset={-5} disabled={dateFilter(date) == -1}>
                <div>{date.getDate()}</div>
            </Indicator>
        );
    };

    return (
        <Popover trapFocus position="bottom" withArrow shadow="md">
            <Popover.Target>
                <ActionIcon variant='transparent' aria-label='Run date'>
                    <FaRegCalendar color='#fff' />
                </ActionIcon>
            </Popover.Target>
            <Popover.Dropdown>
                <DatePicker
                    defaultDate={selectedRun ? selectedRun.date : null}
                    value={selectedRun ? selectedRun.date : null}
                    excludeDate={date => dateFilter(date) == -1}
                    renderDay={dayRenderer}
                    onChange={(value) => {
                        // setLoadingRankings(true)
                        // setLoadingMeshTree(true)
                        changeSelectedRun(availableRuns[dateFilter(value)])
                    }}
                />
            </Popover.Dropdown>
        </Popover>
    );
}

export default RunPicker;
